import React, { useState } from 'react';
import SelectDetailed from 'src/components/formik-fields/selectDetailed/SelectDetailed';
import { CategoryModel, ClickableCategoryModel } from 'src/types/category.model';
import CategoryService from 'src/services/category.service';
import { CustomSubcategoryModalStateModel } from 'src/types/custom-subcategory-modal-state.model';
import { ruleOrTransaction } from 'src/types/ruleOrTransaction';
import { trackClick } from 'src/hooks/useAdobeTags';
import { getCategoryTagName } from 'src/utils/category.utils';
import CustomSubcategoryModal from 'src/components/atomic/organisms/transaction/custom-subcategory-modal/CustomSubcategoryModal';

interface Props<T extends ruleOrTransaction> {
    id: string;
    value: T;
    categories: CategoryModel[];
    pathname: string;
    label?: string;
    tagName?: string;
    hideLabel?: boolean;
    className?: string;
    placeholder?: string;
    disableAlert?: boolean;
    onCloseCustomSubcategoryModal: (category: CategoryModel) => void | Promise<void>;
}

export default function CategorySelectDetailed<T extends ruleOrTransaction>({
    id,
    value,
    categories,
    pathname,
    label,
    tagName,
    hideLabel,
    className,
    placeholder,
    disableAlert = false,
    onCloseCustomSubcategoryModal
}: Props<T>): JSX.Element {
    const [customSubcategoryModalTransaction, setCustomSubcategoryModalTransaction] =
        useState<CustomSubcategoryModalStateModel<T>>(null);

    /* category options with links */
    const categoryOptions: ClickableCategoryModel[] = CategoryService.getCategoryOptions<T>(
        categories,
        value,
        setCustomSubcategoryModalTransaction
    );

    const handleTrackClick = (category: CategoryModel): void => {
        const categoryTag: string = getCategoryTagName(category, categories);
        const fullTagName: string = tagName + '>' + categoryTag;
        trackClick(pathname, fullTagName);
    };

    const customSubcategoryModal: JSX.Element = customSubcategoryModalTransaction && (
        <CustomSubcategoryModal
            categories={categories}
            parentCategoryId={customSubcategoryModalTransaction.parentCategoryId}
            closeModal={async (category?: CategoryModel) => {
                if (category?.id) await onCloseCustomSubcategoryModal(category);
                setCustomSubcategoryModalTransaction(null);
            }}
        />
    );

    return (
        <>
            {customSubcategoryModal}
            <SelectDetailed
                id={id}
                label={label}
                tagName={tagName}
                hideLabel={hideLabel}
                className={className}
                options={categoryOptions}
                placeholder={placeholder}
                customTrackClick={handleTrackClick}
                nested
                disableAlert={disableAlert}
            />
        </>
    );
}
